let ProductDealType = {
  FLASH_DEALS: 1,
  HOT_DEALS: 2,
  TOP_PICKS: 3
}

let ProductDealTypeString = {
  FLASH_DEALS: 'Flash Deals',
  HOT_DEALS: 'Hot Deals',
  TOP_PICKS: 'Top Pick'
}

export { ProductDealType, ProductDealTypeString }
